import React, { PureComponent } from 'react'
import { ModuleVideoPlayer } from '../../../legacy'
import VideoPlayerUI from 'aria-viewer/players/videoplayer/containers/simpleVideoPlayerUI.js'
import isEqual from 'lodash-es/isEqual'
import StopCardStates from 'aria-viewer/stopselector/constants/StopCardStates'
import waitForAction from 'aria-viewer/utils/waitForAction'
import 'public/assets/css/tour/videoui.scss'
import mobileDetect from 'aria-viewer/utils/mobileDetect'
import { PLATFORM } from 'aria-viewer/tour/constants/'
import Style from 'style-it'
import grabCursor from 'public/assets/cursors/grab.cur'
import grabbingCursor from 'public/assets/cursors/grabbing.cur'

const EventEmitter = require('eventemitter3')

/*=============================================
 =            	Environment                   =
 =============================================*/

const isPhone = mobileDetect.phone()
const isMobile = mobileDetect.mobile()

/*=============================================
 =             		Constants                 =
 =============================================*/

const UIHideTiming = {
    IMMEDIATE: 0,
    FASTER: 250,
    FAST: 500,
    SLOW: 3000,
}

// for measuring/triggering mouse clicks
const MOUSE_CLICK_THRESHHOLD_MS = 320,
    MOUSE_DISTANCE_THRESHHOLD_PX = 50

/*=============================================
 =             Component Styling              =
 =============================================*/

const S = {
    videoUIContainer: {
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2001,
    },
    videoWithoutPointerEvents: {
        // position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
    },
    videoWithPointerEvents: {
        // position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'all',
    },
    caretButton: {
        position: 'absolute',
        top: '1.55em',
        left: '1.05em',
        zIndex: 100,
        transform: 'rotate(90deg)',
    },
}

const StyleHelpers = {
    videoPlayerWrapper: ({ cursorClassName, originalStyle }) => ({
        originalStyle,
        cursorClassName,
        style: {
            position: 'relative',
            // overflow: 'hidden',
            display: 'inline-block',
            pointerEvents: 'all',
            zIndex: 0,
            ...originalStyle,
        },
    }),
}

/*=============================================
 =         Supplementary Functions            =
 =============================================*/

function getMouseCoordinates(e) {
    if (e.changedTouches && e.changedTouches[0]) {
        return {
            x: e.changedTouches[0].clientX,
            y: e.changedTouches[0].clientY,
        }
    } else if (e.clientX && e.clientY) {
        return { x: e.clientX, y: e.clientY }
    } else return null
}

/*=============================================
 =              React Component               =
 =============================================*/

class VideoPlayerWrapper extends PureComponent {
    constructor(props) {
        super(props)

        this.player

        this.isMouseOnVideo = true
        this.mouseClickStartedAt = undefined
        this.mouseMoveStartPos = undefined
        this.lastMouseMoveTime = undefined

        this.lastPlayPauseProps = {
            audioManager: props.audioManager,
            audioType: props.audioType,
            allowedAudio: props.allowedAudio,
            canPlayMedia: props.canPlayMedia,
            wasPlaying: props.wasPlaying,
        }

        this.playerWasDestroyed = false

        this.eventEmitter = new EventEmitter()

        this.state = {
            isMouseDown: false,
            isVideoPlaying: true,
            shouldShowDragHint: false,
            hasShownDrag: false,
            showUI: true,
        }

        this.CS = { videoPlayerWrapper: {} }

        this.R = {
            videoPlayerWrapper: undefined,
            videoPlayer: undefined,
        }
    }

    delayedVideoPlayerInit = ({ options }) => {
        const { setVideoPlayer, dragVideoEnd } = this.props
        this.destroy()
        options.eventEmitter = this.eventEmitter
        this.player = ModuleVideoPlayer.createPlayer({
            ...options,
            disableShowDragHintOnLoad: true,
        })

        if (this.player) {
            this.player.embedPlayer(this.R.videoPlayer, '100%', '100%')
            this.player.onPlay(this.handlePlay)
            this.player.onPause(this.handlePause)
            this.player.onFinish(this.handleFinish ? this.handleFinish : () => console.log('FINISH'))
            this.player.onReady(this.handleReady ? this.handleReady : () => console.log('handleReady'))
            this.player.on(
                'dragstart',
                this.handleDragStart ? this.handleDragStart : () => console.log('handleDragStart')
            )
            this.player.on('dragend', dragVideoEnd ? dragVideoEnd : () => console.log('dragVideoEnd'))

            this.playerWasDestroyed = false
            // setVideoPlayer(player)
        }
    }

    registerNewProps = props => {
        const {
            options,
            stopCardsState: nextStopCardState,
            allowedAudio,
            // drawer,
            videoQuality,
            setStartTime,
        } = props

        const {
            stopCardsState,
            // audioManager,
            // audioType,
            videoStartTime,
            // player,
            hideCustomMedia,
        } = this.props

        //pass in the newest audiomanager and audiotype unless its on first load
        // let currentAudioManager = props.audioManager || audioManager
        // let currentAudioType = props.audioType || audioType

        if (!isEqual(options, this.lastOptions)) {
            this.lastOptions = options
            // Timeout appears necessary to avoid failed loading when user immediately clicks trigger after scene loads
            this.delayedRenderTimeout = setTimeout(() => {
                this.delayedVideoPlayerInit(props)
            }, 2000)
        }

        if (videoQuality && !isEqual(videoQuality, this.lastVideoQuality)) {
            this.lastVideoQuality = videoQuality

            this.player && this.player.setQuality(videoQuality)
        }

        if (this.player && videoStartTime && videoQuality) {
            if (videoStartTime != -1) {
                this.player.seek(videoStartTime)
            } else {
                hideCustomMedia()
            }
            setStartTime(null)
        }

        if (
            this.player &&
            this.player.isPlaying() &&
            (allowedAudio != props.audioType &&
                ((stopCardsState == StopCardStates.SHOW) != (nextStopCardState == StopCardStates.SHOW) ||
                    nextStopCardState != stopCardsState))
        ) {
            this.player.pause()
        }
    }

    componentDidMount() {
        this.registerNewProps(this.props)
        const { isFromModal, cancelHideVideoUITimer } = this.props
        if (this.R.videoPlayer) {
            if (!this.is360()) {
                this.R.videoPlayer.addEventListener('mousemove', this.handleMouseOver)
            } else {
                this.R.videoPlayer.addEventListener('mouseleave', cancelHideVideoUITimer)
            }
        }

        waitForAction({ time: 500 }).then(() => {
            this.hasComponentJustMounted = false
        })
    }

    componentWillUnmount() {
        this.destroy()
        const { stopAudio, audioType, isFromModal, cancelHideVideoUITimer } = this.props
        // stopAudio(audioType)

        clearTimeout(this.delayedRenderTimeout)

        if (this.R.videoPlayer) {
            if (!this.is360()) {
                this.R.videoPlayer.removeEventListener('mousemove', this.handleMouseOver)
            } else {
                this.R.videoPlayer.removeEventListener('mouseleave', cancelHideVideoUITimer)
            }

            // if (this.is360() && (!this.props.panoStartLatLon || !this.props.panoStartLatLon.isSetByTrigger)) {
            //     this.props.setPanoStartLatLon({
            //         lat: 0,
            //         lon: 180,
            //         isSetByTrigger: false,
            //     })
            // }

            // if (!this.props.isMediatour) this.props.showUIButton(true)
        }
    }

    destroy = () => {
        const { player, setVideoPlayer } = this.props

        this.playerWasDestroyed = true
        // clearTimeout(this.playPauseTimeout)
        if (this.player) {
            this.player.pause()
            this.player.destroy()
            // setVideoPlayer(null)
            this.player = null
        }
    }

    getContainerParentStyle = ({ cursorClassName, originalStyle }) => {
        if (
            this.CS.videoPlayerWrapper.cursorClassName != cursorClassName ||
            this.CS.videoPlayerWrapper.originalStyle != originalStyle
        ) {
            this.CS.videoPlayerWrapper = StyleHelpers.videoPlayerWrapper({ cursorClassName, originalStyle })
        }

        return this.CS.videoPlayerWrapper.style
    }

    handleVideoAreaClick = e => {
        this.mouseMoveStartPos = getMouseCoordinates(e)
        this.mouseClickStartedAt = new Date()
        this.setState({
            isMouseDown: true,
        })
    }

    handleMouseOver = e => {}

    handleMouseMove = e => {}

    handleMouseUp = e => {
        if (this.mouseMoveStartPos) {
            let mouseHoldLength = new Date() - this.mouseClickStartedAt,
                mouseEndPos = getMouseCoordinates(e),
                mouseDeltaX = mouseEndPos.x - this.mouseMoveStartPos.x,
                mouseDeltaY = mouseEndPos.y - this.mouseMoveStartPos.y,
                mouseDistanceTraveled = Math.sqrt(mouseDeltaX * mouseDeltaX + mouseDeltaY * mouseDeltaY)
            this.mouseMoveStartPos = undefined
            if (mouseDistanceTraveled < MOUSE_DISTANCE_THRESHHOLD_PX) {
                this.setState({ showUI: true })
            }
        }
    }

    handleChange = e => {
        // console.log("handleChange called")
    }

    handleHoverUIControls = e => {
        this.setState({ showUI: true })
    }

    handleHoverUIControlsEnd = e => {
        this.setState({ showUI: false })
    }

    handlePause = e => {
        this.setState({ showUI: true, isVideoPlaying: false })
        this.player.pause()
    }

    handlePlay = e => {
        this.setState({ showUI: false, isVideoPlaying: true })
        this.player.play()
    }

    is360 = () => this.props.options.playback_type == ModuleVideoPlayer.playbackTypes.THREE_SIXTY

    isAWS = () => this.props.options.type == ModuleVideoPlayer.types.AWS

    render() {
        const { isMouseDown, showUI, isVideoPlaying } = this.state
        const {
            options: { theme },
            style,
            isFromModal,
            // player,
            showVideoUI,
        } = this.props

        let containerInteractionProps = !isMobile
            ? {
                  onMouseDown: this.handleVideoAreaClick,
                  onMouseMove: this.handleMouseMove,
                  onMouseUp: this.handleMouseUp,
              }
            : {
                  onTouchStart: this.handleVideoAreaClick,
                  onTouchMove: this.handleMouseMove,
                  onTouchEnd: this.handleMouseUp,
              }

        let cursorClassName

        if (!this.is360()) {
            cursorClassName = 'video_pointer'
        } else {
            cursorClassName = isMouseDown ? 'video_player_grabbing' : 'video_player_grab'
        }

        const isDesktopYTModal =
            this.player && this.player.type == ModuleVideoPlayer.types.YOUTUBE && !isMobile && isFromModal

        return (
            <div>
                <Style>
                    {`
                        .video_player_grab {
                            cursor: move;
                            cursor: url(${grabCursor});
                            cursor: -webkit-grab;
                            cursor: -moz-grab;
                            cursor: grab;
                        }

                        .video_player_grabbing {
                            cursor: url(${grabbingCursor});
                            cursor: -webkit-grabbing;
                            cursor: -moz-grabbing;
                            cursor: grabbing;
                        }

                        .video_player_cursor {
                            cursor: pointer;
                        }
				    `}
                </Style>

                <div
                    ref={c => (this.R.videoPlayerWrapper = c)}
                    className={cursorClassName + ' video_player_wrapper_div'}
                    style={this.getContainerParentStyle({
                        cursorClassName,
                        originalStyle: style,
                    })}
                    {...containerInteractionProps}
                >
                    <div
                        className={'video_player_div'}
                        style={
                            this.is360() || this.isAWS() || isPhone || isDesktopYTModal
                                ? S.videoWithPointerEvents
                                : S.videoWithoutPointerEvents
                        }
                        ref={c => (this.R.videoPlayer = c)}
                    >
                        {/* {player && isVideoUIVisible && ( */}
                        {this.player && showUI && (
                            <VideoPlayerUI
                                // audioType={audioType}
                                isVideoPlaying={isVideoPlaying}
                                onControlsHover={this.handleHoverUIControls}
                                onControlsHoverEnd={this.handleHoverUIControlsEnd}
                                onChange={this.handleChange}
                                onPlay={this.handlePlay}
                                onPause={this.handlePause}
                                player={this.player}
                                style={S.videoUIContainer}
                                theme={Object.assign({}, theme, {
                                    platform: isPhone ? PLATFORM.mobile : PLATFORM.desktop,
                                })}
                            />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoPlayerWrapper
